<template>
  <div>
    <div class="searchArea">
      <a-date-picker v-model:value="formState.date" placeholder="选择日期" style="width: 280px;" />
      <a-button type="primary" shape="circle" @click="handleSearch">
        <template #icon>
          <SearchOutlined />
        </template>
      </a-button>

      <a-button style="margin-left: 10px" @click="handleReset">重置</a-button>
    </div>

    <a-table class="ant-table-striped" :columns="columns" :data-source="data"
      :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" bordered rowKey="uuid"
      :scroll="{ x: 1500 }" :pagination="false">

      <template #operation="{ record }">
        <a-button v-if="!record.orderId" type="primary" size="small" @click="showLinkModal(record)">关联</a-button>
        <a-popconfirm v-else title="确定要取消关联该医保订单吗?" ok-text="确认" cancel-text="取消" @confirm="handleUnlink(record)">
          <a-button type="default" size="small">移除</a-button>
        </a-popconfirm>
        <!-- <a-button style="margin-left: 8px" size="small" @click="handleResetCoupon(record)">重置</a-button> -->
      </template>
    </a-table>

    <!-- 关联优惠券弹窗 -->
    <LinkCouponModal v-model:visible="linkVisible" :orderList="orderList" :currentDate="formState.date"
      :currentRecord="currentRecord" @select="handleLinkOrder" @cancel="handleLinkCancel" />
  </div>
</template>

<script>
import { SearchOutlined } from "@ant-design/icons-vue";
import { cloneDeep } from "lodash-es";
import moment from "moment";
import {
  GetMedicalInsuranceCouponList,
  GetMedicalInsuranceOrderList,
  LinkMedicalOrder,
  UnlinkMedicalOrder,
  ResetCoupon,
} from "/src/api/customerCoupon.js";
import LinkCouponModal from "/src/components/LinkCouponModal.vue";

export default {
  name: "优惠券关联",
  components: {
    SearchOutlined,
    LinkCouponModal,
  },
  emits: ["update:visible"],
  data() {
    return {
      formState: {
        date: moment(),
      },
      columns: [
        { title: "客户", dataIndex: "customerName", key: "customerName", width: 100, align: "center" },
        { title: "电话", dataIndex: "customerMobile", key: "customerMobile", width: 100, align: "center" },
        { title: "优惠券编号", dataIndex: "couponCode", key: "couponCode", width: 120, align: "center" },
        { title: "使用金额/优惠券金额", dataIndex: "feeAmount", key: "feeAmount", width: 180, align: "center" },
        { title: "实际使用人", dataIndex: "actualUserName", key: "actualUserName", width: 120, align: "center" },
        { title: "医保编号", dataIndex: "medicalInsuranceCode", key: "medicalInsuranceCode", width: 120, align: "center" },
        { title: "领券日期", dataIndex: "claimDate", key: "claimDate", width: 120, align: "center" },
        { title: "使用日期", dataIndex: "usedDate", key: "usedDate", width: 120, align: "center" },
        { title: "医保订单", dataIndex: "orderId", key: "orderId", width: 120, align: "center" },
        { title: "订单金额", dataIndex: "orderAmount", key: "orderAmount", width: 100, align: "center" },
        { title: "操作", key: "operation", width: 160, align: "center", slotName: "operation", slots: { customRender: "operation" } },
      ],
      data: [],
      linkVisible: false,
      currentRecord: null,
      orderList: [],
      searchName: "",
    };
  },
  mounted() {
    // 从路由查询参数中读取 usedAt（支持外部链接直达，如 ?usedAt=2026-07-2）
    const routeQuery = this.$route.query;
    if (routeQuery.usedAt) {
      this.formState.date = moment(routeQuery.usedAt);
    }
    this.handleSearch();
  },
  methods: {
    async handleSearch() {
      try {
        const usedAt = this.formState.date.format("YYYY-MM-DD");
        const params = {
          usedAt,
          feeType: "医保",
        };

        const res = await GetMedicalInsuranceCouponList(params);
        if (res.errCode === 0) {
          const list = (res.data || []).map((item) => ({
            ...item,
            customerName: item.customer.name || "",
            customerMobile: item.customer.mobile || "",
            couponCode: item.displayNumber || "",
            feeAmount: `${item.actualAmount || 0}/${item.template?.amount || 0}`,
            actualUserName: item.actualUser || "",
            medicalInsuranceCode: item.medicalInsuranceNumber || "",
            claimDate: item.claimedAt ? item.claimedAt.split(" ")[0] : "",
            usedDate: item.usedAt ? item.usedAt.split("T")[0] : "",
            orderId: item.orderId || "",
            orderAmount: item.extOrderItem?.zongRuzhang || 0,
          }));
          this.data = list;
        }
      } catch (error) {
        console.error("Search error:", error);
        this.$message.error("查询失败");
      }
    },
    handleReset() {
      this.formState.date = moment();
      this.handleSearch();
    },
    async showLinkModal(record) {
      this.currentRecord = cloneDeep(record);
      this.searchName = "";

      try {
        const params = {
          date: this.formState.date.format("YYYY-M-D"),
        };
        const res = await GetMedicalInsuranceOrderList(params);
        if (res.errCode === 0) {
          const mappedList = (res.data || []).map((order) => {
            const firstItem = order.items && order.items.length > 0 ? order.items[0] : {};
            return {
              id: order.id,
              customerName: order.customerName || "",
              medicalInsuranceCode: order.cardNumber || "",
              orderDate: order.date || "",
              zongRuzhang: firstItem.zongRuzhang || 0,
              orderItemId: firstItem.id || order.id,
              receiptNumber: firstItem.receiptNumber || "",
              xianjin: firstItem.xianjin || 0,
            };
          });

          const currentName = record.actualUser || "";
          if (currentName) {
            mappedList.sort((a, b) => {
              const aMatch = a.customerName === currentName ? 0 : 1;
              const bMatch = b.customerName === currentName ? 0 : 1;
              return aMatch - bMatch;
            });
          }

          this.orderList = mappedList;
        }
      } catch (error) {
        console.error("Get orders error:", error);
        this.$message.error("获取医保订单失败");
      }

      this.linkVisible = true;
    },
    async handleLinkOrder(orderRecord) {
      if (!this.currentRecord) return;

      try {
        const data = {
          uuid: this.currentRecord.uuid,
          orderId: orderRecord.id,
          orderItemId: orderRecord.orderItemId || orderRecord.id,
        };

        const res = await LinkMedicalOrder(data);
        if (res.errCode === 0) {
          this.$message.success("关联成功");
          this.linkVisible = false;
          this.handleSearch();
        } else {
          this.$message.error(res.errMsg || "关联失败");
        }
      } catch (error) {
        console.error("Link error:", error);
        this.$message.error("关联失败");
      }
    },
    async handleUnlink(record) {
      try {
        const data = {
          uuid: record.uuid,
        };

        const res = await UnlinkMedicalOrder(data);
        if (res.errCode === 0) {
          this.$message.success("移除成功");
          this.handleSearch();
        } else {
          this.$message.error(res.errMsg || "移除失败");
        }
      } catch (error) {
        console.error("Unlink error:", error);
        this.$message.error("移除失败");
      }
    },
    async handleResetCoupon(record) {
      try {
        const data = {
          uuid: record.uuid,
        };

        const res = await ResetCoupon(data);
        if (res.errCode === 0) {
          this.$message.success("重置成功");
          this.handleSearch();
        } else {
          this.$message.error(res.errMsg || "重置失败");
        }
      } catch (error) {
        console.error("Reset error:", error);
        this.$message.error("重置失败");
      }
    },
    handleLinkCancel() {
      this.linkVisible = false;
      this.currentRecord = null;
      this.orderList = [];
      this.searchName = "";
    },
  },
};
</script>

<style scoped></style>